module.exports = __webpack_public_path__ + "static/media/slide1.31e95bed.jpg";